import airtableProvider from "../../providers/prod/airtable";
import {
	AddOn,
	AddOnPermissionType,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	UsageStats,
	UsageStatsType,
} from "../../../../index";

const a002AddOn = new AddOn({
  internalId: "a002",
  externalId: "pro_01h7b75hjbzmm72hy73jw8gqfp",
  shortName: "Airtable download attachments",
  longName: "Airtable download attachments",
  shortDescription: "Download attachments from Airtable",
  longDescription:
    "* Download attachments in bulk.\n* Use advanced features, such as grouping the attachments, downloading only a subset of attachments.\n* Downloading the attachments can be done locally on your device and not on our servers, to ensure your data is kept private. Or can be done through our servers (check our documentation for more details).\n* When using this extension through our remote servers, there is a limit of 10GB per month.\n* This extension works with any file type and for multiple attachments in a single cell.",
  type: AddOnType.APP_EXTENSION,
  iconAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a002/icons/a002_icon_rounded.png"
  ),
  coverAsset: Asset.image(
    "https://storage.googleapis.com/cdn.version2.io/add-ons/a002/assets/background2.png"
  ),
  previewAssets: [
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a002/screenshots/a002_screenshot_1.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a002/screenshots/a002_screenshot_2.png"
    ),
    Asset.image(
      "https://storage.googleapis.com/cdn.version2.io/add-ons/a002/screenshots/a002_screenshot_3.png"
    ),
  ],
  docsUrl: "https://docs.version2.io/344qzLGKEMBRK8rQD",
  providersIds: [airtableProvider._.id],
  status: AddOnStatus.ACTIVE,
  plans: [
    new AddOnPlan({
      billingCycle: BillingCycle.yearly(),
      internalId: "a002_p001",
      externalId: "pri_01h7b7997hw312bm2m961ewh7b",
      prices: [new Price({ currency: Currency.USD, amount: 28 })],
    }),
    new AddOnPlan({
      billingCycle: BillingCycle.monthly(),
      internalId: "a002_p002",
      externalId: "pri_01h7b78gse0xh9672q2a3h6y1j",
      prices: [new Price({ currency: Currency.USD, amount: 4 })],
    }),
  ],
  settingsConfig: [],
  usageStats: [
    new UsageStats({
      id: "remote_bytes",
      name: "Remote bytes",
      description:
        "The total number of bytes downloaded from the remote server.",
      type: UsageStatsType.BYTES,
      max: 1073741824,
    }),
    new UsageStats({
      id: "remote_files",
      name: "Remote files",
      description:
        "The total number of files downloaded from the remote server.",
      type: UsageStatsType.FILES,
    }),
  ],
  highlightFeatures: [
    new HighlightFeature({
      title: "Any file type",
      description:
        "Works with any file type and for multiple attachments in a single cell.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/file-text.svg",
    }),
    new HighlightFeature({
      title: "Live preview",
      description:
        "Preview the files size and the total size before downloading the files.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/eye.svg",
    }),
    new HighlightFeature({
      title: "Advanced filters",
      description:
        "Use advanced filters to download only a subset of attachments.",
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/filter.svg",
    }),
    new HighlightFeature({
      title: "Local processing",
      description:
        'You can use the "Local processing" option to download the attachments locally on your device and not on our servers.',
      icon: "https://storage.googleapis.com/cdn.version2.io/icons/safety.svg",
    }),
  ],
  allowedPermissionTypes: [
    AddOnPermissionType.AIRTABLE_ACCOUNT,
		AddOnPermissionType.AIRTABLE_ACCOUNT_INVITE,
    AddOnPermissionType.AIRTABLE_BASE,
		AddOnPermissionType.AIRTABLE_SHARED,
  ],
});

export default a002AddOn;
